import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackCancelled.meta';

export type UseTrackCreditPackCancelledParams = CreditAnalyticsParams & {
  source?: Exclude<OpenCreditPackModalLocations, 'checkout'>;
};

export const useTrackCreditPackCancelled = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackCancelled = useCallback(
    (params: UseTrackCreditPackCancelledParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackCancelled };
};
